import FourOhFour from 'components/404'

/**
 *
 * Repurposes the 404 page to display an error message when an unexpected error occurs.
 */
export function ErrorFallback() {
	return (
		<FourOhFour
			ctaLabel="View all open positions"
			ctaUrl="/careers/open-positions"
			message={'An unexpected error occurred. Please try again later.'}
			title={`We're sorry.`}
		/>
	)
}
